import { Box, Modal, Typography } from '@mui/material';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import React from 'react';

interface ManageViewModalProps {
  open: boolean;
  onClose: () => void;
}

const ManageViewModal: React.FC<ManageViewModalProps> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="manage-views-modal">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          p: 4,
          width: '100%',
          maxWidth: 685,
          height: '100%',
          maxHeight: 516,
          minHeight: 516,
        }}
      >
        <Typography
          id="manage-views-modal"
          variant="h6"
          mb={1}
          fontSize={24}
          lineHeight="36px"
          fontWeight={600}
        >
          Manage Views
        </Typography>
        <Typography
          variant="body2"
          fontSize={18}
          lineHeight="24px"
          fontWeight={400}
          sx={(theme) => ({
            color: theme.palette.secondary.main,
          })}
        >
          Edit, rename, or delete your saved views to keep them organized.
        </Typography>
        <Box>
          <Typography
            mt={2}
            fontSize={14}
            lineHeight="21px"
            fontWeight={600}
            sx={(theme) => ({
              color: theme.palette.text.primary,
            })}
          >
            Views
          </Typography>
          {/* Placeholder for saved views list */}
        </Box>
        <Box mt={3} display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <CustomIconButton text="Cancel" onClick={onClose} background="transparent" variant="contained" />
          <CustomIconButton text="Save Changes" onClick={onClose} variant="contained" />
        </Box>
      </Box>
    </Modal>
  );
};

export default ManageViewModal;
